import React, {Component} from 'react';
import {connect} from 'react-redux';
import Const from 'constants';
import Title from 'components/atoms/title';
import Tooltip from 'components/atoms/tooltip';
import FilterInput from './filter-input';
import FilterSlider from './filter-slider';

class FilterByPoints extends Component {
    constructor(props) {
        super(props);
        this.resetSettingsSignature = null;
    }

    componentDidUpdate() {
        if (this.wasSettingReset()) {
            this.updateSettingSignature();
        }
    }

    wasSettingReset() {
        const {resetSettings} = this.props;
        return resetSettings.getSignature() !== this.resetSettingsSignature;
    }

    updateSettingSignature() {
        const {resetSettings} = this.props;
        this.resetSettingsSignature = resetSettings.getSignature();
    }

    getMode() {
        const {mode = Const.FLEX_MODE, boundary} = this.props;
        if (boundary.hasInnerMode(mode)) {
            return mode;
        }

        return Const.FLEX_MODE;
    }

    getModeConfig() {
        const {modesConfig} = this.props;

        return modesConfig.getConfig(this.getMode());
    }

    render() {
        const {
            title = '{modeName} FP Range',
            tooltip = 'Filter {modeName} Position By Fantasy Points Proj Range',
            useDragging,
        } = this.props;

        const modeConfig = this.getModeConfig();
        if (isEmpty(modeConfig)) {
            return null;
        }

        const modeRole = modeConfig.getRole();
        const modeName = modeConfig.getLabel();
        const testIdModeName = modeName && modeName.toLowerCase() + '-';

        return (
            <div className="filters-cell proj-cell">
                <div key={`slider-salary-${this.resetSettingsSignature}`} className="filter-group">
                    <strong className="filter-title">
                        <Tooltip subject={tooltip} replacements={{modeName}} />
                        <Title subject={title} replacements={{modeName}} />
                    </strong>
                    <div className="range-holder">
                        <div className="slider-wrap">
                            <FilterSlider useDragging={useDragging} mode={modeRole} />
                        </div>
                        <div className="range-wrap">
                            <FilterInput mode={modeRole} fieldName="min" testId={`min-${testIdModeName}fp-input`} />
                            <FilterInput mode={modeRole} fieldName="max" testId={`max-${testIdModeName}fp-input`} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {pointsBoundary, reset, modesConfig} = state;

    return {
        boundary: pointsBoundary,
        modesConfig,
        resetSettings: reset.settings,
    };
}

export default connect(mapStatesToProps)(FilterByPoints);
